import React from 'react'

import BaseModal from '../base-modal'
import {
  ModalForm,
  ModalFormRow,
  ModalFormBlock
} from '../modal-form/modal-form'

const constraints = {
  'width': '706px',
  'minWidth': '706px'
}

export default ({
  fields: {
    typedSignature
  },

  handleClose,
  modalTitle,
  handleSubmit,

  submitting,

  loading,
  error,
}) => {
  if (loading) return <p>Loading...</p>

  return (
    <BaseModal
      onClose={handleClose}
      title={modalTitle}
      constraints={constraints}
      contentClassName='work-orders-create-container'
    >
      <ModalForm onSubmit={handleSubmit} customClassName='work-orders-create-form justified-center'>
        <p className={(error && !submitting) ? 'error' : 'error hidden'}>{error}</p>
        <ModalFormRow>
          <ModalFormBlock>
            <label htmlFor='location'>signature</label>
            <input type='text' placeholder='Type your full name' {...typedSignature} />
          </ModalFormBlock>
        </ModalFormRow>

        <ModalFormRow>
          <ModalFormBlock submitButton>
            <button type='submit'>Sign Off</button>
          </ModalFormBlock>
        </ModalFormRow>
      </ModalForm>
    </BaseModal>
  )
}



// WEBPACK FOOTER //
// ./src/components/work-summaries/work-summary-sign-off.js